export default __webpack_public_path__ + "static/media/Project-2-SingleProject-MobileDisplay.5b4f147d.png";